import { initializeApp } from "firebase/app"
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDm-7NRGLJM2oSEj5q8raoXr5dkFbgI9j0",
  authDomain: "qapp-b633d.firebaseapp.com",
  projectId: "qapp-b633d",
  storageBucket: "qapp-b633d.appspot.com",
  messagingSenderId: "232880132027",
  appId: "1:232880132027:web:8b891dfecf9d76ebc43e9e",
  measurementId: "G-1VEDWTZYZ5"
};
export const fetchToken = async () => {
  return getToken(messaging, { vapidKey: "BFVJ-g2FIvjUnjCYlXcoBGxcjswrI16IMTYy62WYzVrsczUrh9011KZ5EBOLNF110_e6qVfQEYTHEiSNfe1GPd0" })
}

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);


export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
       resolve(payload);
    });
  });